<ng-container *transloco="let t">
<div class="w-100">
  <h3 class="my-2 d-flex justify-content-center">
    <span style="max-width: 500px" class="text-gray-700 fs-4 fw-bold"> {{ t('portal.prequal.downPaymentQuestion') }} </span>
  </h3>
  <div class="my-2 d-flex justify-content-center">
    <div style="max-width: 500px">
      <form #downPaymentForm="ngForm" novalidate class="form-horizontal">
        <div class="row p-4 mb-3">
          <div class="form-group mb-3 col-md-12">
            <currency-input
              #downPaymentNumberInput="ngModel"
              [(ngModel)]="request.downPayment"
              name="purchasePriceNumber"
              [allowDecimals]="false"
              [min]="minDownPaymentValue"
              [max]="maxDownPaymentValue"
              [placeholder]="t('portal.prequal.stepPurchasePrice')"
            ></currency-input>

            <input
              type="range"
              class="form-control-range w-100"
              [(ngModel)]="request.downPayment"
              name="downPaymentRange"
              [min]="minDownPaymentValue"
              [max]="maxDownPaymentValue"
              step="5000"
              required
              #downPaymentRangeInput="ngModel"
              [ngClass]="{
                'is-invalid':
                  downPaymentRangeInput &&
                  downPaymentRangeInput.touched &&
                  downPaymentRangeInput.invalid
              }"
            />
          </div>
          <small class="text-center text-muted"
            >{{ t('portal.prequal.downPaymentSliderHint') }}</small
          >
        </div>
      </form>
    </div>
  </div>

  <div class="d-flex justify-content-between my-2">
    <span>
      <a
        href="javascript:void(0)"
        class="btn btn-light"
        (click)="closeClicked()"
      >
        {{ t('common.close') }}
      </a>
    </span>
    <span>
      <a
        href="javascript:void(0)"
        class="btn bp-primary-bg-color me-2"
        (click)="backClicked()"
      >
        {{ t('common.back') }}
      </a>
      <a
        href="javascript:void(0)"
        class="btn bp-primary-bg-color"
        (click)="nextClicked()"
      >
        {{ t('common.next') }}
      </a>
    </span>
  </div>
</div>
</ng-container>
